function selectAnswer(event, button, questionId) {
    event.preventDefault(); // ボタンクリック時のデフォルト動作（ページの上に戻る）をキャンセル

    // 同じ質問内のボタンから"selected"クラスを削除
    const buttons = button.parentElement.querySelectorAll('.custom--button');
    buttons.forEach(btn => {
      btn.classList.remove('selected');
    });

    // クリックされたボタンに"selected"クラスを追加
    button.classList.add('selected');

    // 質問IDに応じて選択結果を保持
    questionAnswers[questionId] = true;

    // 現在の選択結果を表示（デモとしてコンソールに表示）
    console.log(questionAnswers);
  }

  // ボタンの選択状態を切り替える関数
  function toggleAnswer(event, button, questionId) { // eventパラメータを追加
    event.preventDefault(); // ボタンクリック時のデフォルト動作（ページの上に戻る）をキャンセル

    const isSelected = button.classList.contains('selected');

    if (isSelected) {
      // 選択済みの場合、選択状態を解除
      button.classList.remove('selected');
      removeFromArray(uestionAnswers[questionId], button.textContent);
    } else {
      // 選択されていない場合、選択状態に追加
      button.classList.add('selected');
      questionAnswers[questionId].push(button.textContent);
    }

    // 現在の選択結果を表示（デモとしてコンソールに表示）
    console.log(questionAnswers);
  }

  // 配列から要素を削除する関数
  function removeFromArray(array, value) {
    const index = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  function thanksanswer() {
    // hiddenSection要素を取得
    var section = document.getElementById('thanks-section');

    // スタイルのdisplayプロパティを計算されたスタイルから取得
    var computedStyle = window.getComputedStyle(section);

    // スタイルが非表示の場合に表示に切り替え、それ以外の場合は非表示にする
    if (computedStyle.display === 'none' || !section.style.display) {
      section.style.display = 'block';

      // thanks-sectionまでスクロール
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      section.style.display = 'none';
    }
  }